import {useContext} from 'react'

import Card from './back-components/card'
import Logo from './back-components/logo'
import Header from './back-components/header'
import BackFields from './back-components/back-fields'
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined'
import FeedbackOutlinedIcon from '@mui/icons-material/FeedbackOutlined'

import {AppContext} from '/providers/app-context'

const GoogleBack = () => {

  const {user} = useContext(AppContext)
  
  return (
    <Card>
      <GoogleIcons show={user.preferences.show_standard_items} />

      <div className="flex flex-row w-full justify-between items-center pt-1 pl-4 pr-4 pb-2">
        <Logo />
      </div>

      <div className="pl-5 pr-5 pb-2">
        <Header /> 
      </div>

      <div>
        <BackFields show={user.preferences.show_standard_items} />
      </div>
    </Card>
  )
}

const GoogleIcons = ({ show }) => {
  if (show) return (
    <div className="nav-icons">
      <ArrowBackOutlinedIcon className="arrow"/>
      <FeedbackOutlinedIcon className="feedback"/>
    </div>
  )
}

export default GoogleBack